import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { USER_TYPE_CD } from 'src/assets/static/constants';
import { Page } from 'src/components/Page';
import { useStores } from 'src/models';
import { PATH_PAGE } from 'src/routes/paths';

type AuthGuardProps = {
  children: React.ReactNode;
};

/*
 * 관리자만 접근 가능
 */

function AdminGuard({ children }: AuthGuardProps) {
  const { authStore } = useStores();
  const { user } = authStore;

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (user?.userTypeCd?.code !== USER_TYPE_CD.ADMIN) {
    return <Navigate to={PATH_PAGE.home} replace />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return (
    <Page id="auth" style={{ padding: 0, height: '100%' }}>
      {children}
    </Page>
  );
}

export default observer(AdminGuard);
